import * as models from '@/models';
// eslint-disable-next-line jsdoc/require-jsdoc -- When touching please add documentation.
export class Grader extends models.NormalUser {
    // eslint-disable-next-line jsdoc/require-jsdoc -- When touching please add documentation.
    static fromApiServerData(data) {
        return new Grader(data, data.weight, data.done);
    }
    // eslint-disable-next-line jsdoc/require-jsdoc -- When touching please add documentation.
    constructor(user, weight, done) {
        super(user);
        this.weight = weight;
        this.done = done;
    }
    /** @returns The id of the user, here for backwards comparability reasons. */
    get userId() {
        return this.id;
    }
    /** @returns The user of this grader. */
    get user() {
        return models.User.findUserById(this.userId) ?? this;
    }
    // eslint-disable-next-line jsdoc/require-jsdoc -- When touching please add documentation.
    setStatus(value) {
        return new Grader(this, this.weight, value);
    }
}
